import {Component, Input, OnInit} from '@angular/core';
import {SurveyService} from '../../../services/surveys.service';
import {Router} from '@angular/router';
import {PageEvent} from '@angular/material/paginator';

@Component({
    selector: 'app-survey-questions-dashboard',
    templateUrl: './survey-questions-dashboard.component.html',
    styleUrls: ['./survey-questions-dashboard.component.scss'],
    standalone: false
})
export class SurveyQuestionsDashboardComponent implements OnInit {
  @Input() survey: any;

  loading = false;
  surveyQuestionHistories = null;
  currentPageIndex: number = 0;
  pageSize: number = 1;
  totalSurveyQuestionHistories = 0;

  constructor(
    private surveyService: SurveyService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.loadSurveyQuestionsHistories(this.currentPageIndex + 1, this.pageSize);
  }

  loadSurveyQuestionsHistories(page: number, perPage: number) {
    this.loading = true;
    this.surveyService.getSurveyQuestionsHistoriesBySurveyID(this.survey?.id, page, perPage, (result) => {
      this.surveyQuestionHistories = result.data;
      this.totalSurveyQuestionHistories = result.total;
      this.loading = false;
    }, (err) => {
      this.loading = false;
    });
  }

  onPageChange(event: PageEvent) {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadSurveyQuestionsHistories(this.currentPageIndex + 1, this.pageSize);
  }
}
